import produce from 'immer';
import { createPropsFinder, createPropsSelector } from './utils';

export const selectAbsenceBalances = (state) => state.bo.absenceBalances.absenceBalances || produce([], () => {});

export const selectAbsenceBalancesByProps = createPropsSelector(selectAbsenceBalances);
export const findAbsenceBalancesByProps = createPropsFinder(selectAbsenceBalances);
